import browsers from './browsers'
import oss from './os'
import osTypes from './os-types'

export const configuration = [browsers, osTypes, oss]
